/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyPostPharmacyListImageTypename = "PharmacyPostPharmacyListImage" as const;

/**
 *
 * @export
 * @interface PharmacyPostPharmacyListImage
 */
export interface PharmacyPostPharmacyListImage {
  /**
   *
   * @type {string}
   * @memberof PharmacyPostPharmacyListImage
   */
  data: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPostPharmacyListImage
   */
  detail?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPostPharmacyListImage
   */
  readonly __typename?: string;
}

export function PharmacyPostPharmacyListImageFromJSON(json: any): PharmacyPostPharmacyListImage {
  return PharmacyPostPharmacyListImageFromJSONTyped(json, false);
}

export function PharmacyPostPharmacyListImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPostPharmacyListImage {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPostPharmacyListImageTypename,

    data: json["data"],
    detail: !exists(json, "detail") ? undefined : json["detail"],
  };
}

export function PharmacyPostPharmacyListImageToJSON(object?: PharmacyPostPharmacyListImage | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    data: value.data,
    detail: value.detail,
  };
}
